<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">業務設定</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="showCreateFormDialog">業務追加</button>
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right uk-overflow-auto">
			<table id="shop_job_type_table" class="uk-table uk-table-expand uk-table-striped">
				<thead>
				<tr>
					<th>NO.</th>
					<th>業務名</th>
					<th>画面表示名</th>
					<th>サイネージ表示名</th>
					<th>配色</th>
					<th>サイネージ用配色</th>
					<th>所要時間</th>
					<th>予約対象</th>
					<th>店舗業務<br>BY業務</th>
					<th>休憩<br>研修</th>
					<th>空き枠</th>
					<th>有効<br><span style="color: #b9e0d9">※一括選択できます</span><br><input id="bulk_check_action" class="uk-checkbox" type="checkbox" @click="bulkCheckAction"></th>
					<th>更新日</th>
					<th>操作</th>
					<th>編集</th>
				</tr>
				</thead>
				<tbody class="tbody">
				<template v-for="(shop_job_type, index) in shop_job_types">
					<tr class="row data_row" :key="index" :data-id="shop_job_type.id">
						<td>{{ shop_job_type.id }}</td>
						<td>{{ shop_job_type.job_type.name }}</td>
						<td>{{ shop_job_type.display_name }}</td>
						<td>{{ shop_job_type.signage_display_name }}</td>
						<td><span v-bind:style="'color:'+ shop_job_type.color.hex">■</span></td>
						<td><span v-bind:style="'color:'+ shop_job_type.signage_color.hex">■</span></td>
						<td>{{ shop_job_type.duration_minute }}分</td>
						<template v-if="shop_job_type.is_reservation">
							<td><input class="uk-checkbox" name="is_reservation" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="is_reservation" type="checkbox"></td>
						</template>
						<template v-if="shop_job_type.is_shop_or_by">
							<td><input class="uk-checkbox" name="is_shop_or_by" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="is_shop_or_by" type="checkbox"></td>
						</template>
						<template v-if="shop_job_type.is_rest_or_training">
							<td><input class="uk-checkbox" name="is_rest_or_training" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="is_rest_or_training" type="checkbox"></td>
						</template>

						<!-- 空き枠 -->
						<template v-if="shop_job_type.job_type.unoccupied_status == 1">
							<td><input class="uk-checkbox" name="unoccupied_status" type="checkbox" disabled checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="unoccupied_status" type="checkbox" disabled></td>
						</template>

						<template v-if="shop_job_type.status == 0">
							<td><input class="uk-checkbox" name="status" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="status" type="checkbox"></td>
						</template>
						<td>{{ shop_job_type.updated_at | moment }}</td>
						<td class="data_row_handle">&#8645;</td>
						<td>
							<button class="uk-button uk-button-default" @click="showEditDialog(shop_job_type.id)">編集</button>
						</td>
					</tr>
				</template>
				<tr class="row">
					<td>
						<button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				</tbody>
			</table>
		</div>
		<div class="uk-container uk-container-expand uk-margin-small-bottom">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="saveEditShopJobType">保存</button>
			</div>
		</div>
		<!--/ Main -->
		<!-- CreateFormDialog -->
		<div id="create_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_job_type_name">業務名 (必須)</label>
							<div class="uk-form-controls">
								<select id="create_form_job_type_name" class="uk-select" name="job_type" @change="onCreateDialogSelectJobType">
									<template v-for="(job_type, index) in job_types">
										<option :key="index" :value="job_type.id">{{ job_type.name}}</option>
									</template>
								</select>
								<template v-if="typeof this.createFormState.errors.job_type_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.job_type_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_display_name">表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
								<template v-if="typeof this.createFormState.errors.display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_signage_display_name">サイネージ表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_signage_display_name" name="signage_display_name" type="text" placeholder="サイネージ表示名を入力してください" required>
								<template v-if="typeof this.createFormState.errors.signage_display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.signage_display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_color">配色 (必須)</label>
							<div class="uk-form-controls uk-padding-small" style="background: #666">
								<div class="uk-grid">
									<template v-for="(color, index) in colors">
										<div class="uk-grid-inline" :key="index">
											<label for="create_form_color" :key="index">
												<input id="create_form_color" class="uk-radio" name="color" type="radio" v-bind:value="color.id">
												<span style="font-size: 42px !important; line-height: 1;" v-bind:style="{color: color.hex}">■</span>
											</label>
										</div>
									</template>
								</div>
								<template v-if="typeof this.createFormState.errors.color_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.color_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_color">サイネージ用配色</label>
							<div class="uk-form-controls uk-padding-small" style="background: #666">
								<div class="uk-grid">
									<template v-for="(color, index) in colors">
										<div class="uk-grid-inline" :key="index">
											<label for="create_form_signage_color" :key="index">
												<input id="create_form_signage_color" class="uk-radio" name="signage_color" type="radio" v-bind:value="color.id">
												<span style="font-size: 42px !important; line-height: 1;" v-bind:style="{color: color.hex}">■</span>
											</label>
										</div>
									</template>
								</div>
								<template v-if="typeof this.createFormState.errors.signage_color_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.signage_color_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_duration_minute">所要時間 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="create_form_duration_minute" name="duration_minute" type="text" placeholder="所要時間を入力してください" required maxlength="20">
								<template v-if="typeof this.createFormState.errors.duration_minute != undefined">
									<template v-for="(error,index) in this.createFormState.errors.duration_minute">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_is_reservation">予約対象</label>
							<div class="uk-form-controls">
								<input class="uk-checkbox" id="create_form_is_reservation" name="is_reservation" type="checkbox">
								<template v-if="typeof this.createFormState.errors.is_reservation != undefined">
									<template v-for="(error,index) in this.createFormState.errors.is_reservation">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_is_shop_or_by">店舗業務<br>BY業務</label>
							<div class="uk-form-controls">
								<input class="uk-checkbox" id="create_form_is_shop_or_by" name="is_shop_or_by" type="checkbox">
								<template v-if="typeof this.createFormState.errors.is_shop_or_by != undefined">
									<template v-for="(error,index) in this.createFormState.errors.is_shop_or_by">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_is_rest_or_training">休憩<br>研修</label>
							<div class="uk-form-controls">
								<input class="uk-checkbox" id="create_form_is_rest_or_training" name="is_rest_or_training" type="checkbox">
								<template v-if="typeof this.createFormState.errors.is_rest_or_training != undefined">
									<template v-for="(error,index) in this.createFormState.errors.is_rest_or_training">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateFormDialog -->
		<!-- EditFormDialog -->
		<div id="edit_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_job_type_name">業務名 (必須)</label>
							<div class="uk-form-controls">
								<select id="edit_form_job_type_name" class="uk-select" name="job_type" @change="onEditDialogSelectJobType">
									<template v-for="(job_type, index) in job_types">
										<option :key="index" :value="job_type.id">{{ job_type.name}}</option>
									</template>
								</select>
								<template v-if="typeof this.createFormState.errors.job_type_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.job_type_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_display_name">表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="edit_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
								<template v-if="typeof this.createFormState.errors.display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_signage_display_name">サイネージ表示名 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="edit_form_signage_display_name" name="signage_display_name" type="text" placeholder="サイネージ表示名を入力してください" required>
								<template v-if="typeof this.createFormState.errors.signage_display_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.signage_display_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_color">配色 (必須)</label>
							<div class="uk-form-controls uk-padding-small" style="background: #666">
								<div class="uk-grid">
									<template v-for="(color, index) in colors">
										<div class="uk-grid-inline" :key="index">
											<label :key="index">
												<input id="edit_form_color" class="uk-radio" name="color" type="radio" v-bind:value="color.id">
												<span style="font-size: 42px !important; line-height: 1;" v-bind:style="{color: color.hex}">■</span>
											</label>
										</div>
									</template>
								</div>
								<template v-if="typeof this.createFormState.errors.color_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.color_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_color">サイネージ用配色</label>
							<div class="uk-form-controls uk-padding-small" style="background: #666">
								<div class="uk-grid">
									<template v-for="(color, index) in colors">
										<div class="uk-grid-inline" :key="index">
											<label :key="index">
												<input id="edit_form_signage_color" class="uk-radio" name="signage_color" type="radio" v-bind:value="color.id">
												<span style="font-size: 42px !important; line-height: 1;" v-bind:style="{color: color.hex}">■</span>
											</label>
										</div>
									</template>
								</div>
								<template v-if="typeof this.createFormState.errors.signage_color_id != undefined">
									<template v-for="(error,index) in this.createFormState.errors.signage_color_id">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_duration_minute">所要時間 (必須)</label>
							<div class="uk-form-controls">
								<input class="uk-input" id="edit_form_duration_minute" name="duration_minute" type="text" placeholder="所要時間を入力してください" required maxlength="20">
								<template v-if="typeof this.createFormState.errors.duration_minute != undefined">
									<template v-for="(error,index) in this.createFormState.errors.duration_minute">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_is_reservation">予約対象</label>
							<div class="uk-form-controls">
								<input class="uk-checkbox" id="edit_form_is_reservation" name="is_reservation" type="checkbox">
								<template v-if="typeof this.createFormState.errors.is_reservation != undefined">
									<template v-for="(error,index) in this.createFormState.errors.is_reservation">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_is_shop_or_by">店舗業務<br>BY業務</label>
							<div class="uk-form-controls">
								<input class="uk-checkbox" id="edit_form_is_shop_or_by" name="is_shop_or_by" type="checkbox">
								<template v-if="typeof this.createFormState.errors.is_shop_or_by != undefined">
									<template v-for="(error,index) in this.createFormState.errors.is_shop_or_by">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_is_rest_or_training">休憩<br>研修</label>
							<div class="uk-form-controls">
								<input class="uk-checkbox" id="edit_form_is_rest_or_training" name="is_rest_or_training" type="checkbox">
								<template v-if="typeof this.createFormState.errors.is_rest_or_training != undefined">
									<template v-for="(error,index) in this.createFormState.errors.is_rest_or_training">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveEditForm">保存</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ EditFormDialog -->
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'
	import ShopJobType from '@/api/ShopJobType'
	import JobType from '@/api/JobType'
	import Color from '@/api/Color'
	import Role from '@/api/Role'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import Sortable from 'sortablejs'

	export default {
		name: 'ShopJobTypeMasterPage',
		comments: [],
		data () {
			return {
				need_confirm_alert: false,
				current_staff: null,
				job_types: [],
				shop_job_types: [],
				colors: [],
				createFormState: {
					errors: []
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			onCreateDialogSelectJobType: function () {
				let name = $('#create_form_job_type_name option:selected').text()

				if (name.length > 4) {
					name = name.substr(0, 4)
				}

				$('#create_form_display_name').val(name)
			},
			onEditDialogSelectJobType: function () {
				let name = $('#edit_form_job_type_name option:selected').text()

				if (name.length > 4) {
					name = name.substr(0, 4)
				}

				$('#edit_form_display_name').val(name)
			},
			showEditDialog: function (id) {
				this.createFormState.errors = []
				$('#edit_form_dialog').data('id', id)

				let self = this
				let params = new URLSearchParams()
				params.append('id', id)

				ShopJobType.one(params).then(function (response) {
					let data = response.data.data

					$('#edit_form_job_type_name option[value="' + data.job_type.id + '"]').prop('selected', true)
					$('#edit_form_display_name').val(data.display_name)
					$('#edit_form_signage_display_name').val(data.signage_display_name)
					$('#edit_form_duration_minute').val(data.duration_minute)
					$('#edit_form_color[value="' + data.color_id + '"]').prop('checked', true)
					$('#edit_form_signage_color[value="' + data.signage_color_id + '"]').prop('checked', true)

					if (data.is_reservation) {
						$('#edit_form_is_reservation').prop('checked', true)
					} else {
						$('#edit_form_is_reservation').prop('checked', false)
					}

					if (data.is_shop_or_by) {
						$('#edit_form_is_shop_or_by').prop('checked', true)
					} else {
						$('#edit_form_is_shop_or_by').prop('checked', false)
					}

					if (data.is_rest_or_training) {
						$('#edit_form_is_rest_or_training').prop('checked', true)
					} else {
						$('#edit_form_is_rest_or_training').prop('checked', false)
					}

					UIkit.modal($('#edit_form_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			saveEditForm: function () {
				let self = this

				let id = $('#edit_form_dialog').data('id')

				// サイネージ表示名が半角スペースのみの場合、全角スペースに置換
				let signage_display_name = $('#edit_form_signage_display_name').val()
				let signage_display_name_reg = new RegExp('^ +$')
				if (signage_display_name_reg.test(signage_display_name)) {
					signage_display_name = signage_display_name.replace(/\s/g, '　')
				}

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('job_type_id', $('#edit_form_job_type_name option:selected').val())
				params.append('display_name', $('#edit_form_display_name').val())
				params.append('signage_display_name', signage_display_name)
				params.append('duration_minute', $('#edit_form_duration_minute').val())
				params.append('color_id', $('#edit_form_color:checked').val())
				params.append('signage_color_id', $('#edit_form_signage_color:checked').val())
				params.append('is_reservation', $('#edit_form_is_reservation').prop('checked'))
				params.append('is_shop_or_by', $('#edit_form_is_shop_or_by').prop('checked'))
				params.append('is_rest_or_training', $('#edit_form_is_rest_or_training').prop('checked'))

				ShopJobType.update(params).then(function (response) {
					alert('保存完了')
					location.reload()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/shop')
						location.reload()
					}
				} else {
					this.$router.push('/shop')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#shop_job_type_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#shop_job_type_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditShopJobType () {
				let self = this
				let length = $('#shop_job_type_table .data_row_before_save').length

				$('#shop_job_type_table .data_row').each(function (i) {
					let index = i
					// 並び順は「１」から(０は新規追加の場合とする)
					let order_by = i + 1

					let id = $(this).data('id')
					let status = 1

					if ($(this).find('[name="status"]').prop('checked')) {
						status = 0
					}

					let is_reservation = false

					if ($(this).find('[name="is_reservation"]').prop('checked')) {
						is_reservation = true
					}

					let is_shop_or_by = false

					if ($(this).find('[name="is_shop_or_by"]').prop('checked')) {
						is_shop_or_by = true
					}

					let is_rest_or_training = false

					if ($(this).find('[name="is_rest_or_training"]').prop('checked')) {
						is_rest_or_training = true
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('status', status)
					params.append('is_reservation', is_reservation)
					params.append('is_shop_or_by', is_shop_or_by)
					params.append('is_rest_or_training', is_rest_or_training)
					params.append('order_by', order_by)

					ShopJobType.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							location.reload()
						}
					})
				})

				//	location.reload()
			},
			saveCreateForm () { // ダイアログ保存
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data
					let job_type_id = $('#create_form [name="job_type"]').val()
					let display_name = $('#create_form [name="display_name"]').val()
					let signage_display_name = $('#create_form [name="signage_display_name"]').val()
					let duration_minute = $('#create_form [name="duration_minute"]').val()
					let color_id = null
					let signage_color_id = null
					let is_reservation = false
					let is_shop_or_by = false
					let is_rest_or_training = false
					let order_by = 0

					if ($('#create_form [name="color"]:checked').val() != undefined) {
						color_id = $('#create_form [name="color"]:checked').val()
					}

					if ($('#create_form [name="signage_color"]:checked').val() != undefined) {
						signage_color_id = $('#create_form [name="signage_color"]:checked').val()
					}

					if ($('#create_form_is_reservation').prop('checked')) {
						is_reservation = true
					}

					if ($('#create_form_is_shop_or_by').prop('checked')) {
						is_shop_or_by = true
					}

					if ($('#create_form_is_rest_or_training').prop('checked')) {
						is_rest_or_training = true
					}

					// サイネージ表示名が半角スペースのみの場合、全角スペースに置換
					let signage_display_name_reg = new RegExp('^ +$')
					if (signage_display_name_reg.test(signage_display_name)) {
						signage_display_name = signage_display_name.replace(/\s/g, '　')
					}

					let params = new URLSearchParams()
					params.append('display_name', display_name)
					params.append('signage_display_name', signage_display_name)
					params.append('duration_minute', duration_minute)
					params.append('job_type_id', job_type_id)
					params.append('is_reservation', is_reservation)
					params.append('is_shop_or_by', is_shop_or_by)
					params.append('is_rest_or_training', is_rest_or_training)
					params.append('shop_id', staff.shop_id)
					params.append('order_by', order_by)

					if (color_id != null) {
						params.append('color_id', color_id)
					}

					if (signage_color_id != null) {
						params.append('signage_color_id', signage_color_id)
					}

					ShopJobType.create(params).then(function (response) {
						alert('保存完了')
						location.reload()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				this.createFormState.errors = []
				this.onCreateDialogSelectJobType()
				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			loadColors () {
				let self = this

				Color.all().then(function (response) {
					self.colors = response.data.data
				})
			},
			loadShopJobTypes () {
				let self = this

				StaffAuth.current().then(function (response) {
					return response.data.data
				}).then(function (staff) {
					let params = new URLSearchParams()
					params.append('shop_id', staff.shop_id)

					ShopJobType.all(params).then(function (response) {
						self.shop_job_types = response.data.data
					})
				})
			},
			loadJobTypes () {
				let self = this

				let params = new URLSearchParams()
				params.append('status', 0)

				JobType.all(params).then(function (response) {
					self.job_types = response.data.data
				})
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#shop_job_type_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			this.loadJobTypes()
			this.loadShopJobTypes()
			this.loadColors()
			this.registerDataChangeEvent()

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 管理者スタッフではない場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}
			})

			$('#edit_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_form_dialog')).hide()
				}
			})

			$('#create_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			Sortable.create($('#shop_job_type_table .tbody')[0], {
				handle: '.data_row_handle',
				draggable: '.data_row',
				dragoverBubble: true,
				onEnd: function (event) {
					$(event.item).addClass('data_row_before_save')
				},
				onMove: function (event) {
					$(event.item).addClass('data_row_before_save')
				}
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#shop_job_type_table {
		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/ShopJobTypeMasterPage.vue